export default __webpack_public_path__ + "static/media/article.12fc473d.jpeg";